/* eslint-disable */
/* prettier-ignore */
import * as utils from '../utils'

export default {
  prefix: 'cus',
  iconName: 'warehouse',
  icon: [
    480, // width
    480, // height
    [],
    null,
    `
      M415.433,117.073c-0.112-0.272-0.28-0.504-0.416-0.76c-0.297-0.577-0.665-1.115-1.096-1.6
			c-0.486-0.458-0.974-0.914-1.464-1.368l-168-112c-2.688-1.794-6.192-1.794-8.88,0l-168,112c-0.49,0.454-0.978,0.91-1.464,1.368
			c-0.431,0.486-0.799,1.023-1.096,1.6c-0.136,0.264-0.304,0.488-0.416,0.76c-0.357,0.894-0.547,1.846-0.56,2.808l-0.048,0.104v352
			c0,4.418,3.582,8,8,8h336c4.418,0,8-3.582,8-8v-352v-0.104C415.98,118.919,415.79,117.967,415.433,117.073z M239.993,17.585
			l141.6,94.4h-283.2L239.993,17.585z M287.993,463.985h-80v-64h80V463.985z M287.993,383.985h-64v-48h64V383.985z M287.993,319.985
			h-72c-4.418,0-8,3.582-8,8v56h-8c-4.418,0-8,3.582-8,8v72h-80v-224h176V319.985z M287.993,223.985h-176v-16h176V223.985z
			 M287.993,191.985h-176v-16h176V191.985z M399.993,463.985h-96v-296c0-4.418-3.582-8-8-8h-192c-4.418,0-8,3.582-8,8v296h-16v-336
      h320V463.985
      
      M375.993,295.985h-48c-4.418,0-8,3.582-8,8v96c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-96
      C383.993,299.567,380.411,295.985,375.993,295.985z M367.993,391.985h-32v-80h32V391.985
      
      M375.993,231.985h-48c-4.418,0-8,3.582-8,8v32c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8v-32
			C383.993,235.567,380.411,231.985,375.993,231.985z M367.993,263.985h-32v-16h32V263.985
      
      z
    ` // svg path data
  ]
}



// WEBPACK FOOTER //
// ./src/components/icon/custom-icons/custom-icons/warehouse.js